;
( function( $, window, document, undefined )
{
    'use strict';

    var optimiser = function( element, options )
    {
        this.options = options;
        this.els     = options.els;
        this.init();
    };

    optimiser.prototype = {

        init : function()
        {
            this.removeLithiumStuffMaybe();
            this.pagination();
            // this.tabs();
        },

        tabs: function () {
            $('.CM090_inlineTabs ul').each(function () {
                var width = 0;
                $(this).find('li').each(function () {
                    width += parseInt($(this).width()) + 1;
                });

                $(this).css('width', width);
            });
        },

        pagination: function () {
            $('.lia-paging-page-previous .lia-paging-page-arrow').html('<span class="icon icon--light"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="15" height="20" viewBox="0 0 7.5 10"><path d="M4.061,5.051 L7.461,8.068 L5.417,10.002 L-0.004,5.051 L5.529,-0.001 L7.499,1.798 L4.061,5.051 Z" class="cls-1"/></svg></span');
            $('.lia-paging-page-next .lia-paging-page-arrow').html('<span class="icon icon--light"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="15" height="20" viewBox="0 0 7.5 10"><path d="M3.439,4.949 L0.039,1.932 L2.083,-0.002 L7.504,4.949 L1.971,10.001 L0.001,8.202 L3.439,4.949 Z" class="cls-1"/></svg></span>');
        },

        removeLithiumStuffMaybe : function()
        {
            var $pdc6 = this.els.$pdc6;
            if( $pdc6.hasClass( 'home' ) || $pdc6.hasClass( 'browse-topics' ) )
            {
                $( 'script[src$="body-min.js"]' ).remove();
                $( 'script[src$="common-min.js"]' ).remove();
                $( 'script[src$="head-min.js"]' ).remove();
            }
        }

    };

    $.fn.optimiser = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'optimiser' );

        if( !instance )
        {
            instance = new optimiser( this, options );
            $item.data( 'optimiser', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );
